import {
  updateFamilyMembersData,
  useGetFamilyMembers,
} from '@/common/integrations/menhir/employee/employee/employee.hooks';

export function useFamilyMembers() {
  const { familyMembers } = useGetFamilyMembers();

  return {
    loading: !familyMembers,
    allMembers: familyMembers?.sort(
      (a, b) => (a.type > b.type ? -1 : a.type < b.type ? 1 : 0) // Spouse first
    ),
    children: familyMembers?.filter((m) => m.type === 'child'),
    spouse: familyMembers?.find((m) => m.type === 'spouse'),
    getFamilyMember: (memberId: string) =>
      familyMembers?.find((member) => member.id === memberId),
    updateFamilyMember: updateFamilyMembersData,
  };
}
